import React from "react";

function SellFormArticle({title, text}) {

    return (
        <div
            className="block h-fit p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
            <h5 className="mb-2 text-lg md:text-2xl font-bold tracking-tight">
                {title}
            </h5>
            <div className="text-sm md:text-md font-normal">
                {text}
            </div>
        </div>
    );
}

export default SellFormArticle;